/** Keep the deadline active until the complete search body has arrived. */
export async function fetchSearchResponse(
  url: string,
  options: RequestInit,
  timeoutMs = 60_000,
  transport: (url: string, options: RequestInit) => Promise<Response> = fetch,
): Promise<Response> {
  const controller = new AbortController();
  const cancel = () => controller.abort(options.signal?.reason);
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  options.signal?.addEventListener('abort', cancel, { once: true });
  if (options.signal?.aborted) cancel();
  try {
    const response = await transport(url, { ...options, signal: controller.signal });
    const body = await response.arrayBuffer();
    return new Response(body, {
      status: response.status,
      statusText: response.statusText,
      headers: response.headers,
    });
  } catch (error) {
    if (controller.signal.aborted && !options.signal?.aborted) {
      throw new Error('Căutarea a depășit timpul de așteptare. Puteți încerca din nou.');
    }
    throw error;
  } finally {
    clearTimeout(timer);
    options.signal?.removeEventListener('abort', cancel);
  }
}
